import React from 'react';
import { bool, number } from 'prop-types';
import { Button } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import withImpressions from '../../../../hoc/withImpressions';
import { REVIEWS_HEADER, TEXT } from '../../../../../../constants';

const IMPRESSION_COMPONENT_CLASS = 'stars-filter';

const impressionConfig = {
    DOMSelector: `.${IMPRESSION_COMPONENT_CLASS}`,
    getImpressionData: (data, { rating, value }) => ({
        page: {
            element: {
                name: 'reviews_breakdown',
                type: TEXT,
                text: rating,
                metadata: value,
            },
            component: {
                name: REVIEWS_HEADER,
            },
        },
    }),
};

const FilterButton = ({ noRating, selected, value }) => {
    const btnDisabledColor = Button.COLORS.GREY;
    const btnActiveColor = Button.COLORS.BLACK;

    const btnColor = noRating ? btnDisabledColor : btnActiveColor;
    const btnFill = selected ? Button.FILLS.FULL : Button.FILLS.GHOST;

    return (
        <Button className={IMPRESSION_COMPONENT_CLASS} fill={btnFill} color={btnColor} disabled={noRating}>
            <I18n k="reviews.breakdown.stars" params={{ count: value }} />
        </Button>
    );
};

FilterButton.propTypes = {
    noRating: bool,
    selected: bool,
    value: number,
    // eslint-disable-next-line react/no-unused-prop-types
    rating: number,
};

export default withImpressions(FilterButton, impressionConfig);
